import React, { useState } from 'react';
import { Modal, ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { Button } from '@fiverr-private/button';
import { useLandingPage } from '../../../context/LandingPageContext';

interface ErrorModalProps {
    title?: string;
    subtitle: string;
    buttonText: string;
}

export const ErrorModal = ({ title, subtitle, buttonText }: ErrorModalProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(true);
    const { setIsBottomDrawerOpen } = useLandingPage();

    const handleClose = () => {
        setIsOpen(false);
        setIsBottomDrawerOpen(false);
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <ModalContent size="sm">
                {title && (
                    <ModalHeader>
                        {title}
                        <ModalCloseBtn />
                    </ModalHeader>
                )}
                <ModalBody>{subtitle}</ModalBody>
                <ModalFooter>
                    <Button onClick={handleClose}>{buttonText}</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
